import React, { ReactNode } from 'react';

const Span = ({ children, ...props }: {children: ReactNode; props?: {[x:string]: any}}) => <span {...props}>{children}</span>;

export default Span;
